module.exports = __webpack_public_path__ + "img/zuofeicaozuo.1da66615.png";